import { getSpeechToText } from '@wix/ambassador-genie-chat-service-v1-no-entity/http';
import { useCallback } from 'react';
export const useSpeechToText = _ref => {
  let {
    httpClient
  } = _ref;
  const getTextFromSpeech = useCallback(async (audioBlob, language) => {
    if (!httpClient) {
      throw new Error('httpClient is not defined');
    }
    try {
      const arrayBuffer = await audioBlob.arrayBuffer();
      const audioData = new Uint8Array(arrayBuffer);
      const requestPayload = getSpeechToText({
        audioData,
        language
      });
      const {
        data
      } = await httpClient.request(requestPayload);
      return {
        text: data.text || '',
        success: true
      };
    } catch (error) {
      return {
        text: '',
        success: false,
        error: error instanceof Error ? error.message : 'Unknown error'
      };
    }
  }, [httpClient]);
  return {
    getTextFromSpeech
  };
};
//# sourceMappingURL=useSpeechToText.js.map